import getMatchingVariant from '../utils/variants/getMatchingVariant';
import updatePrice from '../utils/variants/updatePrice';
import updateSelectedVariant from '../utils/variants/updateSelectedVariants';
import updateFormControls from '../utils/variants/updateFormControls';
import updateURL from '../utils/variants/updateURL';
import preselectVariant from '../utils/variants/preselectVariant';
import updateVariantImages from '../utils/variants/updateVariantImages';
import updateProductGallery from '../utils/product/updateProductGallery';

const initProductVariants = (container = document.querySelector('[data-product-main]')) => {
  const variantEls = container.querySelectorAll('[data-variant-input]');
  if (!variantEls.length) return;

  const form = container.querySelector('[data-product-form]');
  if (!form) return;

  const variantsDataEl = form.querySelector('[data-product-variants-json]');
  const optionNamesEl = form.querySelector('[data-product-options-json]');
  const variantInventoryEl = form.querySelector('[data-product-variants-inventory-policy-json]');
  const variantIdInput = form.querySelector('[data-atc-id-input]');
  const quantitySelector = form.querySelector('[data-quantity-selector]');
  const quantityInput = quantitySelector?.querySelector('[data-quantity-input]');
  const atcButton = form.querySelector('button[type="submit"]');
  const atcButtonPrice = atcButton?.querySelector('[data-atc-price]');
  const atcButtonMsg = atcButton?.querySelector('[data-atc-price-msg]');
  const atcButtonPipe = atcButton?.querySelector('[data-atc-price-pipe]');
  const productPreOrderMsg = container.querySelector('[data-product-preorder-msg]');
  const productSoldInfo = container.querySelector('[data-product-sold-info]');
  const productControls = container.querySelector('[data-product-controls]');
  const klaviyoBIS = container.querySelector('[data-klaviyo-bis]');

  let variantsData = [];
  let optionNames = [];
  let variantInventory = [];

  try {
    variantsData = JSON.parse(variantsDataEl?.textContent || '[]');
    optionNames = JSON.parse(optionNamesEl?.textContent || '[]');
    variantInventory = JSON.parse(variantInventoryEl?.textContent || '[]');
  } catch (e) {
    console.error('Invalid variant/options JSON', e);
    return;
  }

  const selectedOptions = {};

  const priceContainer = document.querySelector('[data-product-price-pdp]');
  const priceEl = priceContainer?.querySelector('[data-product-price]');
  const compareAtPriceEl = priceContainer?.querySelector('[data-product-compare-at-price]');
  const badgeEl = priceContainer?.querySelector('[data-product-sale-badge]');

  const updateVariantDetails = () => {
    const variant = getMatchingVariant(selectedOptions, variantsData, optionNames);
    if (!variant) return;

    variantIdInput && (variantIdInput.value = variant.id);
    updatePrice({
      priceEl,
      compareAtPriceEl,
      badgeEl,
      price: variant.price,
      compareAtPrice: variant.compare_at_price,
      badgeTemplate: window.theme.strings.priceBadgeText
    });

    updateSelectedVariant({
      variant,
      variantInventory,
      elements: {
        productPreOrderMsg,
        productSoldInfo,
        productControls,
        klaviyoBIS,
        atcButtonMsg
      },
      strings: window.theme.strings
    });

    updateURL({ variantID: variant.id });
    if (!variant.available) {
      klaviyoBIS.dataset.unavailableVariantId = variant.id;
    }

    updateFormControls({
      variant,
      qty: +quantityInput.value,
      variantsData,
      optionNames,
      selectedOptions,
      atcButton,
      atcButtonPrice,
      atcButtonPipe,
      quantitySelector
    });

    updateProductGallery(container, variant);
    updateVariantImages(container, selectedOptions, variantsData, optionNames);
  };

  const updateSelectedOption = (name, value) => {
    selectedOptions[name] = value;
    updateVariantDetails();
  };

  variantEls.forEach(variant => {
    variant.addEventListener('change', ({ target }) => {
      const { name, value } = target;
      updateSelectedOption(name, value);
    });
  });

  preselectVariant({
    variantsData,
    optionNames,
    form,
    selectedOptions,
    updateSelectedOption,
    updateVariantDetails,
    variantIdInput
  });
};

export default initProductVariants;
